module.exports = _.mapValues;